export default [{
  path: '/locatario',
  name: 'tenantInfo',
  component: () => import('@/feature/tenant/views/TenantInfo.vue'),
}, {
  path: '/locatario/opcoes',
  name: 'tenantPaymentOptions',
  component: () => import('@/feature/tenant/views/TenantPaymentOptions.vue'),
}, {
  path: '/locatario/sumario',
  name: 'tenantSummary',
  component: () => import('@/feature/tenant/views/TenantSummary.vue'),
}];
